import { PrizmLanguageInputLayoutDateTime } from '../../interfaces';

export const PRIZM_RUSSIAN_INPUT_LAYOUT_DATE_TIME: PrizmLanguageInputLayoutDateTime = {
  inputLayoutDateTime: {
    wrongFormat: 'Неправильный формат данных',
  },
};
